import i18next from '../i18next';
import * as React from 'react';
import { Typography } from 'antd';

export type FAQQuestion = {
  question: string;
  answer: string | React.ReactNode | JSX.Element;
};

export type FAQCategory = {
  category: string;
  questions: FAQQuestion[];
};

export type FAQList = FAQCategory[];

export const getFAQ = (): FAQList => {
  return [
    {
      category: i18next.t('faq.category.generalEnquires'),
      questions: [
        {
          question: i18next.t('faq.question.addPickupLocation'),
          answer: i18next.t('faq.answer.addPickupLocation')
        },
        {
          question: i18next.t('faq.question.setDefaultAddress'),
          answer: i18next.t('faq.answer.setDefaultAddress')
        },
        {
          question: i18next.t('faq.question.deleteAddress'),
          answer: i18next.t('faq.answer.deleteAddress')
        },
        {
          question: i18next.t('faq.question.setInvoice'),
          answer: i18next.t('faq.answer.setInvoice')
        },
        {
          question: i18next.t('faq.question.paymentMethod'),
          answer: i18next.t('faq.answer.paymentMethod')
        }
      ]
    },
    {
      category: i18next.t('faq.category.onDemandDelivery'),
      questions: [
        {
          question: i18next.t('faq.question.createDelivery'),
          answer: i18next.t('faq.answer.createDelivery')
        },
        {
          question: i18next.t('faq.question.trackDelivery'),
          answer: i18next.t('faq.answer.trackDelivery')
        },
        {
          question: i18next.t('faq.question.activeDeliveries'),
          answer: i18next.t('faq.answer.activeDeliveries')
        },
        {
          question: i18next.t('faq.question.pastDeliveries'),
          answer: i18next.t('faq.answer.pastDeliveries')
        },
        {
          question: i18next.t('faq.question.driverNotes'),
          answer: i18next.t('faq.answer.driverNotes')
        },
        {
          question: i18next.t('faq.question.cashOnDelivery'),
          answer: i18next.t('faq.answer.cashOnDelivery')
        },
        {
          question: i18next.t('faq.question.orderId'),
          answer: i18next.t('faq.answer.orderId')
        },
        {
          question: i18next.t('faq.question.cancellationConditions'),
          answer: i18next.t('faq.answer.cancellationConditions')
        },
        {
          question: i18next.t('faq.question.cancelDelivery'),
          answer: i18next.t('faq.answer.cancelDelivery')
        },
        {
          question: i18next.t('faq.question.useWalletForDeliveries'),
          answer: (
            <>
              <Typography.Text strong>
                {i18next.t('faq.answer.useWalletForDeliveries.firstParagraphTitle')}
              </Typography.Text>
              {i18next.t('faq.answer.useWalletForDeliveries.firstParagraphText')}
              <Typography.Text strong>
                {i18next.t('faq.answer.useWalletForDeliveries.secondParagraphTitle')}
              </Typography.Text>
              {i18next.t('faq.answer.useWalletForDeliveries.secondParagraphText')}
              <Typography.Text strong>
                {i18next.t('faq.answer.useWalletForDeliveries.thirdParagraphTitle')}
              </Typography.Text>
              {i18next.t('faq.answer.useWalletForDeliveries.thirdParagraphText')}
              <table>
                <thead>
                  <tr>
                    <th>{i18next.t('faq.answer.useWalletForDeliveries.row1col1')}</th>
                    <th>{i18next.t('faq.answer.useWalletForDeliveries.row1col2')}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{i18next.t('faq.answer.useWalletForDeliveries.row2col1')}</td>
                    <td>{i18next.t('faq.answer.useWalletForDeliveries.row2col2')}</td>
                  </tr>
                  <tr>
                    <td>{i18next.t('faq.answer.useWalletForDeliveries.row3col1')}</td>
                    <td>{i18next.t('faq.answer.useWalletForDeliveries.row3col2')}</td>
                  </tr>
                  <tr>
                    <td>{i18next.t('faq.answer.useWalletForDeliveries.row4col1')}</td>
                    <td>{i18next.t('faq.answer.useWalletForDeliveries.row4col2')}</td>
                  </tr>
                </tbody>
              </table>
              {i18next.t('faq.answer.useWalletForDeliveries.afterTable')}
              <Typography.Text strong>
                {i18next.t('faq.answer.useWalletForDeliveries.fourthParagraphTitle')}
              </Typography.Text>
              {i18next.t('faq.answer.useWalletForDeliveries.fourthParagraphText')}
            </>
          )
        }
      ]
    },
    {
      category: i18next.t('faq.category.dedicatedFleet'),
      questions: [
        {
          question: i18next.t('faq.question.generateOTP'),
          answer: i18next.t('faq.answer.generateOTP')
        },
        {
          question: i18next.t('faq.question.trackOTP'),
          answer: i18next.t('faq.answer.trackOTP')
        },
        {
          question: i18next.t('faq.question.activateOTP'),
          answer: i18next.t('faq.answer.activateOTP')
        },
        {
          question: i18next.t('faq.question.otpPastDeliveries'),
          answer: i18next.t('faq.answer.otpPastDeliveries')
        }
      ]
    }
  ];
};
